import React from 'react';
import { OmniIconComponent } from '../../../../shared';

/**
 * Custom loading cell renderer for AG-Grid
 * Displays a lightweight loading indicator while fetching paginated data
 * @param {Object} props - Renderer props
 * @param {string} props.loadingMessage - Message to display during loading
 * @returns {JSX.Element} Loading indicator component
 */
const CustomLoadingCellRenderer = (props) => {
    return (
        <div className="ag-custom-loading-cell" style={{ 
            paddingLeft: '10px', 
            lineHeight: '42px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }}>
            <div 
                className="spinner-border" 
                style={{ 
                    width: '16px',
                    height: '16px',
                    border: '2px solid transparent',
                    borderTopColor: '#1976d2',
                    borderRightColor: '#1976d2',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite',
                    display: 'inline-block'
                }}
            />
            <span>{props.loadingMessage || 'Loading more campaigns...'}</span>
        </div>
    );
};

export default CustomLoadingCellRenderer;
